<div class="colab-manager-content-component colab-registration fade-in-animation">

  <div class="row" style="margin: 0;">

    <div class="col-md-6 col-sm-12">
      <div class="area-to-overlay">

        <h1 class="no-margin">{{ 'COMPANY.MANAGER.FORM.SECTION_TITLE' | translate }}</h1>

        <!-- Informações básicas -->
        <div class="col-md-12 col-sm-12 no-padding basic-info-wrp">

          <h2>{{ 'COMPANY.MANAGER.FORM.SUBSECTION_TITLE_BASIC_INFO' | translate }}</h2>

          <div class="col-md-6 col-sm-12 form-padding-right">
            <div [ngClass]="{'form-group': true, 'has-error': hasError('first_name')}">
              <label for="firstName">{{ 'COMPANY.MANAGER.FORM.NAME_LABEL' | translate }}*</label>
              <input type="text" class="form-control" id="firstName" [(ngModel)]="employeeData.firstName"
                placeholder="">
              <span class="error-description">{{ getError('first_name') | translate }}</span>
            </div>
          </div>

          <div class="col-md-6 col-sm-12 form-padding-left">
            <div [ngClass]="{'form-group': true, 'has-error': hasError('surname')}">
              <label for="surname">{{ 'COMPANY.MANAGER.FORM.SURNAME_LABEL' | translate }}</label>
              <input type="text" class="form-control" id="surname" [(ngModel)]="employeeData.surname" placeholder="">
              <span class="error-description">{{ getError('surname') | translate }}</span>
            </div>
          </div>

          <div [ngClass]="{'form-group': true, 'has-error': hasError('email')}">
            <label for="email">{{ 'COMPANY.MANAGER.FORM.EMAIL_LABEL' | translate }}</label>
            <input type="email" class="form-control" id="email" [(ngModel)]="employeeData.email">
            <span class="error-description">{{ getError('email') | translate }}</span>
          </div>

          <div class="clearfix"></div>

          <div class="col-md-6 col-sm-12 form-padding-right">
            <div [ngClass]="{'form-group': true, 'has-error': hasError('cpf')}">
              <label for="cpf">{{ 'COMPANY.MANAGER.FORM.CPF_LABEL' | translate }}*</label>
              <input type="text" class="form-control" id="cpf" [textMask]="{mask: cpfMask}"
                [(ngModel)]="employeeData.cpf" placeholder="" [disabled]="isDisabledCpf(employeeData.cpf)">
              <span class="error-description">{{ getError('cpf') | translate }}</span>
            </div>
          </div>

          <div class="col-md-6 col-sm-12 form-padding-left">
            <div [ngClass]="{'form-group': true, 'has-error': hasError('profilesId')}">
              <label for="profile">{{ 'COMPANY.MANAGER.FORM.PROFILE_LABEL' | translate }}*</label>
              <select class="form-control" id="profile" [(ngModel)]="employeeData.profilesId">
                <option value="5a1ef473694cfe4bc3935212">{{ 'COMPANY.MANAGER.FORM.PROFILE_TYPE_MASTER' | translate }}
                </option>
                <option value="5a1ef50d694cfe4bc3935217">{{ 'COMPANY.MANAGER.FORM.PROFILE_TYPE_EMPLOYEE' | translate }}
                </option>
                <option *ngIf="this.typeBusiness === 'company'" value="5a1ef4b2694cfe4bc3935213">{{
                  'COMPANY.MANAGER.FORM.PROFILE_TYPE_FINANCIAL' | translate }}</option>
                <option *ngIf="this.typeBusiness === 'company'" value="5a1ef508694cfe4bc3935215">{{
                  'COMPANY.MANAGER.FORM.PROFILE_TYPE_COMMUNICATION' | translate }}</option>
              </select>
              <span class="error-description">{{ getError('profilesId') | translate }}</span>
            </div>
          </div>

        </div>
        <!-- / Informações básicas -->


        <!-- Opcionais -->
        <div class="col-md-12 col-sm-12 no-padding optional-info-wrp">

          <h2>{{ 'COMPANY.MANAGER.FORM.SUBSECTION_TITLE_OPTIONAL_INFO' | translate }}</h2>

          <!-- Dados pessoais -->
          <div *ngIf="this.typeBusiness === 'company'">
            <h3>{{ 'COMPANY.MANAGER.FORM.SUBSECTION_TITLE_PERSONAL_INFO' | translate }}</h3>

            <div [ngClass]="{'form-group': true, 'has-error': hasError('employeeRegistrationNumber')}">
              <label for="employee_registration_number">{{ 'COMPANY.MANAGER.FORM.EMPLOYEE_REGISTRATION_NUMBER_LABEL' |
                translate }}</label>
              <input type="text" class="form-control" id="employee_registration_number"
                [(ngModel)]="employeeData.employeeRegistrationNumber" placeholder="">
              <span class="error-description">{{ getError('employeeRegistrationNumber') | translate }}</span>
            </div>

            <div [ngClass]="{'form-group': true, 'has-error': hasError('emailPersonal')}">
              <label for="email_personal">{{ 'COMPANY.MANAGER.FORM.EMPLOYEE_PERSONAL_EMAIL_LABEL' | translate }}</label>
              <input type="email" class="form-control" id="email_personal" [(ngModel)]="employeeData.emailPersonal"
                placeholder="">
              <span class="error-description">{{ getError('emailPersonal') | translate }}</span>
            </div>
          </div>
          <div class="form-group">
            <label for="gender">{{ 'COMPANY.MANAGER.FORM.GENDER_LABEL' | translate }}</label>
            <select class="form-control" id="gender" [(ngModel)]="employeeData.gender">
              <option value="female">{{ 'COMPANY.MANAGER.FORM.GENDER_FEMALE' | translate }}</option>
              <option value="male">{{ 'COMPANY.MANAGER.FORM.GENDER_MALE' | translate }}</option>
              <option value="other">{{ 'COMPANY.MANAGER.FORM.GENDER_OTHER' | translate }}</option>
            </select>
          </div>

          <div *ngIf="this.typeBusiness === 'company'" class="form-group">
            <label style="display: block;">{{ 'COMPANY.MANAGER.FORM.HAS_CHILD_LABEL' | translate }}</label>
            <div class="colab-has-childs">
              <div class="col-md-6 has-child-radio">
                <input type="radio" name="hasChilds" [(ngModel)]="employeeData.hasChilds" value="1">
                <label>{{ 'COMPANY.MANAGER.FORM.HAS_CHILD_YES' | translate }}</label>
              </div>
              <div class="col-md-6 has-child-radio">
                <input type="radio" name="hasChilds" [(ngModel)]="employeeData.hasChilds" value="0">
                <label>{{ 'COMPANY.MANAGER.FORM.HAS_CHILD_NO' | translate }}</label>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="phone_number">{{ 'COMPANY.MANAGER.FORM.PHONE_NUMBER_LABEL' | translate }}</label>
            <input type="text" class="form-control" id="phone_number" [textMask]="{mask: telephoneMask}"
              [(ngModel)]="employeeData.phone" placeholder="">
          </div>

          <div class="col-md-6 col-sm-12 form-padding-right">
            <div class="form-group">
              <label for="birth_date">{{ 'COMPANY.MANAGER.FORM.BIRTHDATE_LABEL' | translate }}</label>
              <input type="date" class="form-control" id="birth_date" [(ngModel)]="employeeData.birthDate"
                placeholder="">
            </div>
          </div>

          <!-- Dados pessoais e profissionais de empresa  -->
          <div *ngIf="this.typeBusiness === 'company'">
            <div class="col-md-6 col-sm-12 form-padding-left">
              <div class="form-group">
                <label for="cep">{{ 'COMPANY.MANAGER.FORM.CEP_LABEL' | translate }}</label>
                <input type="text" class="form-control" id="cep" [textMask]="{mask: cepMask}"
                  [(ngModel)]="employeeData.cep" placeholder="">
              </div>
            </div>

            <div class="clearfix"></div>

            <!-- /Dados pessoais -->

            <!-- Dados profissionais-->

            <h3>{{ 'COMPANY.MANAGER.FORM.SUBSECTION_TITLE_PROFESSIONAL_INFO' | translate }} </h3>

            <div class="col-md-6 col-sm-12 form-padding-right">
              <div class="form-group">
                <label for="job_position">{{ 'COMPANY.MANAGER.FORM.JOB_POSITION_LABEL' | translate }}</label>
                <select class="form-control" id="job_position" [(ngModel)]="employeeData.jobPosition">
                  <option value="trainee">{{ 'COMPANY.MANAGER.FORM.JOB_POSITION_TRAINEE' | translate }}</option>
                  <option value="assistant">{{ 'COMPANY.MANAGER.FORM.JOB_POSITION_ASSISTANT' | translate }}</option>
                  <option value="analyst">{{ 'COMPANY.MANAGER.FORM.JOB_POSITION_ANALYST' | translate }}</option>
                  <option value="coordinator">{{ 'COMPANY.MANAGER.FORM.JOB_POSITION_COORDINATOR' | translate }}</option>
                  <option value="manager">{{ 'COMPANY.MANAGER.FORM.JOB_POSITION_MANAGER' | translate }}</option>
                  <option value="director">{{ 'COMPANY.MANAGER.FORM.JOB_POSITION_DIRECTOR' | translate }}</option>
                  <option value="superintendent">{{ 'COMPANY.MANAGER.FORM.JOB_POSITION_SUPERINTENDENT' | translate }}
                  </option>
                  <option value="president">{{ 'COMPANY.MANAGER.FORM.JOB_POSITION_PRESIDENT' | translate }}</option>
                  <option value="other">{{ 'COMPANY.MANAGER.FORM.JOB_POSITION_OTHER' | translate }}</option>
                </select>
              </div>
            </div>

            <div class="col-md-6 col-sm-12 form-padding-left"
              *ngIf="typeBusiness === 'company' && companyGroups?.length > 0">
              <div [ngClass]="{'form-group': true, 'has-error': hasError('companyUnit')}">
                <label for="company_unit">{{ 'COMPANY.MANAGER.FORM.COMPANY_UNIT_LABEL' | translate }}*</label>
                <select class="form-control" id="company_unit" [(ngModel)]="employeeData.costCenterId">
                  <option [value]="unit.id" *ngFor="let unit of companyGroups">{{ unit.name }}</option>
                </select>
                <span class="error-description">{{ getError('companyUnit') | translate }}</span>
              </div>
            </div>
            <!-- /Dados profissionais -->

          </div>
          <!-- Dados pessoais e profissionais de empresa  -->

          <div class="clearfix"></div>

          <div class="buttons-actions-colab-form" *ngIf="isEdit && !isLoading">
            <button class="btn btn-orange-contrast" (click)="sendInvitation()">{{
              'COMPANY.MANAGER.FORM.BUTTON_RESEND_INVITATION' | translate }}</button>
            <button class="btn btn-orange" (click)="updateEmployee()">{{ 'COMPANY.MANAGER.FORM.BUTTON_SAVE_CHANGES' |
              translate }}</button>
          </div>

          <div class="buttons-actions-colab-form" *ngIf="!isEdit && !isLoading">
            <button class="btn btn-orange-contrast" style="margin: 0 15px 0 0" (click)="saveEmployee()">{{
              'COMPANY.MANAGER.FORM.BUTTON_SAVE' | translate }}</button>
            <button class="btn btn-orange" (click)="saveAndSendInvitation()">{{
              'COMPANY.MANAGER.FORM.BUTTON_SAVE_AND_SEND_INVITATION' | translate }}</button>
          </div>

          <div class="loader-wrp" *ngIf="isLoading">
            <div class="loader"><span></span><span></span><span></span></div>
          </div>
        </div>
        <!-- / Opcionais -->


        <div class="loading-overlay" *ngIf="isLoading">
          <div class="loader-wrp">
            <div class="loader"><span></span><span></span><span></span></div>
            <p> {{ 'LOADING' | translate }}</p>
          </div>
        </div>

        <div class="clearfix"></div>

      </div>
    </div>

    <div class="col-md-6 col-sm-12">
      <!-- Robot -->
      <div class="colab-robot animate-fade-in">
        <div class="img-wrp">
          <img src="../../../assets/shared/img/colab-robot.png" alt="Colaboradores - Robô">
        </div>
        <div class="text-wrp" *ngIf="typeBusiness == 'company'">
          Segue algumas dicas de preenchimento: Necessário ter pelo menos o e-mail OU CPF. Perfil Master tem privilégios
          e recebe e-mails administrativos. E as informações complementares ajudam na personalização e relevância, e
          preencher o campo UNIDADE, permitirá relatórios mais específicos para você.
        </div>
        <div class="text-wrp" *ngIf="typeBusiness == 'establishment'">
          Cadastre e treine sua equipe para acessarem a plataforma e lançarem os CUPONS.
        </div>
        <div>
          <!-- / Robot -->
        </div>

      </div>
    </div>